import { createContext } from 'react'
import LengthOfTimeEntry from '../../../LengthOfTime/LengthOfTimeEntry'
import { AddressDetails, AddressHistoryEntry, DisplayState } from '../AddressHistoryContext'

export type ResultOption = {
  [key: string]: string
  label: string
  value: string
}

export type AddressHistoryEntryAction =
  { type: 'PREVIOUS' } |
  { type: 'NEXT' } |
  { type: 'EDIT', value: string } |
  { type: 'UPDATE_STATUS', value: string } |
  { type: 'UPDATE_TIME_IN_SITUATION', value: LengthOfTimeEntry } |
  { type: 'UPDATE_ADDRESS_DETAILS', value: AddressDetails } |
  { type: 'UPDATE_DISPLAY_STATE', value: DisplayState } |
  { type: 'UPDATE_LOQATE_RESULTS', value: ResultOption[] | undefined } |
  { type: 'UPDATE_POSTCODE_SEARCH_LABEL', value: string | null } |
  { type: 'UPDATE_POSTCODE_SEARCH_ATTEMPTED', value: boolean }

interface ContextProps {
  dispatch: ((action: AddressHistoryEntryAction) => void)
}

const AddressHistoryEntryContext = createContext<ContextProps>({
  dispatch: () => { }
})

export type AddressSubQuestion = 'ADDRESS_DETAILS' | 'STATUS' | 'TIME_IN_SITUATION'

export interface AddressHistoryEntryState {
  entry: AddressHistoryEntry
  escapeAction?: 'PREVIOUS' | 'NEXT'
  question: AddressSubQuestion
}

export default AddressHistoryEntryContext
